import VueRouter from 'vue-router'
import Launch from '@/views/launchList/index.vue'
import Bill from '@/views/billManagement/index.vue'
import DataList from '@/views/dataList/index.vue'
import Home from '@/views/dashboard/index.vue'
import Login from '@/views/login/index.vue'
import Register from '@/views/register/index.vue'
import Agreement from '@/views/agreement/index.vue'
import ApplySettlement from "@/views/billManagement/components/applySettlement.vue" 
import SettlementDetails from "@/views/billManagement/components/settlementDetails.vue"
import UserCenter from '@/views/userCenter/index.vue'
import PassWord from '@/views/changePassWord/index.vue'
  var router = new VueRouter({
    // 配置路由骨子额
    mode: 'hash',
    routes: [
        { path: '/', redirect: '/login' },
        {path:'/login',component:Login},
        {path:'/register',component:Register},
        {path:'/agreement',component:Agreement},
        {
          path: '/userCenter',
          component:UserCenter,
         },
         {
          path: '/changePassWord',
          component:PassWord,
         },
        {
          path: '/launchList',
          component:Launch,
         },
         {
          path: '/bill',
          component:Bill,
         },
         {
          path: '/dataList',
          component:DataList,
         },
         {
           path: '/applysettlement',
           component: ApplySettlement,
         },
         {
           path:"/settlementdetails",
           component: SettlementDetails,
         },
         {
          path: '/home',
          component:Home,
         },

    ],
    linkActiveClass: 'mui-active'
})
export default router
